const urlModulDesktop = 'modules/contract/ui/components/desktop';
const urlModulMobile = 'modules/account/ui/components/mobile';

export const componentViews = new Map([
  ['USER_INFO_COMPONENT', { module: 'shared/components', component: 'user-info/user-info' }],
  ['IBAN_INFO', { module: urlModulDesktop, component: 'block-info-bank/info-bank' }],
  ['STATUS_BLOCK_INFO', { module: urlModulDesktop, component: 'contract-status/Contract-status-block' }],
  ['ACTION_BLOCK_BUTTON', { module: urlModulDesktop, component: 'action-button-block/action-button-block' }],

  ['CLAIM_COUNT_WITH_BTN_CONSULT_COMPONENT', { module: urlModulDesktop, component: 'block-claim-number/block-claim-number' }],
  ['CLAIM_ACTION_WITH_STATUS_COMPONENT', { module: urlModulDesktop, component: 'block-contract-status/block-contract-status' }],

  ['CONTRACT_DETAILS_COMPONENT', { module: urlModulDesktop, component: 'contract-engine-tabs/contract-engine-tabs' }],

  [
    'DESKTOP_CHOICE_RESCIND',
    {
      module: urlModulDesktop + '/contract-engine-tabs/desktop-contract-rescind',
      component: 'desktop-contract-rescind',
    },
  ],
  [
    'MOBILE_CHOICE_RESCIND',
    {
      module: 'modules/contract/ui/components/mobile/mobile-contract-resiliation',
      component: 'mobile-contract-resiliation',
    },
  ],

  [
    'DESKTOP_CONTRACT_RECAP',
    {
      module: urlModulDesktop,
      component: 'contract-engine-tabs/tabs/desktop_contract_recap/desktop-contract-recap',
    },
  ],
  ['DESKTOP_INFO_PERSONNLLE', { module: urlModulDesktop, component: 'contract-engine-tabs/tabs/desktop-personal-informations' }],
  [
    'DESKTOP_INFO_BANK',
    {
      module: urlModulDesktop,
      component: 'contract-engine-tabs/tabs/desktop-bank-information/desktop-bank-information',
    },
  ],
  [
    'DESKTOP_COTISATION',
    {
      module: urlModulDesktop,
      component: 'contract-engine-tabs/tabs/desktop-cotisation/desktop-cotisation',
    },
  ],
  ['INSURED_ELEMENTS_INFO', { module: urlModulDesktop, component: 'contract-engine-tabs/tabs/product-insurance' }],
  [
    'CONTRACTUAL_INFO',
    {
      module: urlModulDesktop,
      component: 'contract-engine-tabs/tabs/desktop_contract_recap/contract-documents-tab',
    },
  ],
  ['CONTRACTUAL_INFO_MOBILE', { module: 'modules/contract/ui/components/mobile', component: 'contract-recap/contract-documents-tab' }],
  [
    'CONTRACT_DETAIL_CARD',
    {
      module: urlModulDesktop,
      component: 'contract-engine-tabs/tabs/desktop_contract_recap/contract-detail-cardList',
    },
  ],
  ['CONTACT_COMPONENT', { module: 'modules/contact/ui/components/desktop', component: 'contact-engine-choice/contact-engine-choice' }],

  ['FORM_CONTACT', { module: 'modules/contact/ui/components/desktop/contact-customer', component: 'contact-customer' }],
  ['FORM_CONTACT_MOBILE', { module: 'modules/contact/ui/components/mobile/contact-customer', component: 'contact-customer' }],

  ['CHOOSE_FORM_CONTACT_MODE', { module: 'modules/contact/ui/components/commun/form-contact', component: 'form-contact' }],
  ['CHOOSE_TELEPHONE_CONTACT_MODE', { module: 'modules/contact/ui/components/desktop/mobile-contact', component: 'mobile-contact' }],
  ['CHOOSE_TELEPHONE_CONTACT_MODE_MOBILE', { module: 'modules/contact/ui/components/mobile/mobile-contact', component: 'mobile-contact' }],
  ['USER_INFO_CONTRACT', { module: urlModulDesktop, component: 'user-info/user-info' }],
  ['ADRESSE_INFO', { module: urlModulDesktop, component: 'adresse-info' }],

  ['CONTACT_INFO_CONTRACT', { module: 'modules/contact/ui/components/desktop/tabs', component: 'info-contrat-contact' }],
  ['STORE_INFO_COMPONENT', { module: 'modules/claim/ui/components/desktop/seller-info', component: 'seller-info' }],
  ['USER_INFO_CLAIM', { module: 'modules/claim/ui/components/desktop/user-info-claim', component: 'user-info-claim' }],
  ['CLAIM_TIPS', { module: 'modules/claim/ui/components/desktop/claim-tips', component: 'claim-tips' }],
  ['CLAIM_INFO_TAB', { module: 'modules/claim/ui/components/desktop/desktop-claim-engine', component: 'desktop-claim-engine-slider' }],
  ['BANK_INFO_COMPONENT', { module: 'modules/account/ui/components/desktop', component: 'bank-info' }],

  ['DESKTOP_CONTRACT_TAB', { module: urlModulDesktop + '/desktop-claim-engine/slider-tabs', component: 'desktop-contract-info' }],
  [
    'DESKTOP_CLAIM_EVENT_TAB',
    { module: 'modules/claim/ui/components/desktop/desktop-claim-engine/slider-tabs', component: 'desktop-event' },
  ],
  ['DESKTOP_RECAP_TAB', { module: 'modules/claim/ui/components/desktop/desktop-claim-engine/slider-tabs', component: 'desktop-recap' }],
  [
    'DESKTOP_ESPACE_DOCUMENT_TAB',
    { module: 'modules/claim/ui/components/desktop/desktop-claim-engine/slider-tabs', component: 'desktop-doc' },
  ],
  [
    'DESKTOP_CLAIM_CONTACT_TAB',
    { module: 'modules/claim/ui/components/desktop/desktop-claim-engine/slider-tabs', component: 'desktop-contact' },
  ],

  // Mobile components

  ['MOBILE_SUBSCRIPTION_LIST', { module: 'modules/home/ui/components/mobile/subscription-list', component: 'subscription-list' }],
  ['MOBILE_TO_ACCOUNT_ENGINE', { module: 'modules/home/ui/components/mobile/to-account-engine', component: 'to-account-engine' }],

  ['MOBILE_CONTRACT_ENGINE_TAB', { module: 'pages/mobile/contract-engine', component: 'contract-engine' }],
  ['MOBILE_CLAIM_ENGINE_TAB', { module: 'pages/mobile/claim-engine', component: 'claim-engine' }],
  ['MOBILE_CONTRACT_RECAP', { module: 'modules/contract/ui/components/mobile', component: 'contract-recap' }],

  ['VERIF_SUBSCRIPTION_PROCESS', { module: 'modules/account/ui/components/common', component: 'verif-adh' }],
  ['MOBILE_PRODUCT_TAB', { module: 'modules/contract/ui/components/mobile', component: 'mobile-product' }],
  ['MOBILE_BANKING_INFO_TAB', { module: 'modules/contract/ui/components/mobile', component: 'mobile-bank-info' }],
  ['MOBILE_COTISATION_TAB', { module: 'modules/contract/ui/components/mobile', component: 'mobile-cotisation/mobile-cotisation' }],
  ['MOBILE_USER_TAB', { module: 'modules/contract/ui/components/mobile', component: 'mobile-personal-informations' }],

  ['MOBILE_CONTACT_CHOICE', { module: 'modules/contact/ui/components/mobile', component: 'contact-choice-mode/contact-choice-mode' }],
  ['DESKTOP_CONTACT_CHOICE', { module: 'modules/contact/ui/components/desktop', component: 'contact-choice-mode/contact-choice-mode' }],
  ['MOBILE_RESCIND_CHOICE', { module: 'modules/contract/ui/components/mobile/mobile-contract-rescind', component: 'rescind-contract' }],
  ['RESCIND_LIST', { module: 'modules/contract/ui/components/mobile/mobile-contract-rescind', component: 'rescind-source-choice' }],

  ['MOBILE_CLAIM_EVENT_TAB', { module: 'modules/claim/ui/components/mobile', component: 'mobile-event' }],
  ['MOBILE_ESPACE_DOCUMENT_TAB', { module: 'modules/claim/ui/components/mobile', component: 'mobile-doc' }],
  ['MOBILE_RECAP_TAB', { module: 'modules/claim/ui/components/mobile', component: 'mobile-recap' }],
  ['SUBSCRIPTION_ACCOUNT_SEARCH', { module: 'modules/account/ui/components/common/search-contract', component: 'search-contract' }],
  ['CONTACT_GESTIONNAIRE', { module: 'modules/account/ui/components/common', component: 'gestionnaire-contact' }],
  ['MOBILE_NO_MATCHED_CONTACT', { module: 'modules/account/ui/components/common', component: 'no-matched-adhesion' }],
  [
    'CONTRACT_COSTUMER_ROW',
    { module: 'modules/contract/ui/components/desktop/subscription-customer-item', component: 'subscription-customer-item' },
  ],
  ['EMAIL_ACCOUNT_ATTACHEMENT', { module: 'modules/account/ui/components/common/assignement-contract', component: 'assignement-contract' }],
  ['SEARCH_SPACE', { module: 'modules/contract/ui/components/desktop/search-form', component: 'search-form' }],
  ['SEARCH_SPACE_CLAIM', { module: 'modules/claim/ui/components/desktop/search-form', component: 'search-form' }],
  ['CONTRACT_PDV_ROW', { module: urlModulDesktop + '/contract-row-item', component: 'contract-row-item' }],
  ['CLAIM_COSTUMER_ROW', { module: 'modules/claim/ui/components/desktop/customer-tab-items', component: 'customer-claim-tab-item' }],
  ['CLAIM_LIST_ROW', { module: 'modules/claim/ui/components/mobile', component: 'mobile-claimlist-item' }],
  ['CLAIM_PDV_ROW', { module: 'modules/claim/ui/components/desktop/tab-items', component: 'claim-tab-item' }],
  ['CUSTOMER_CLAIM_SPACE', { module: 'modules/claim/ui/components/desktop/customer-claim-space', component: 'customer-claim-space' }],

  ['INFO_USER_COMP_ROW', { module: urlModulDesktop + '/subscription-customer-item/info-customer', component: 'info-customer' }],
  ['INFO_CONTRACT_COMP_ROW', { module: urlModulDesktop + '/subscription-customer-item/subscription-info', component: 'subscriptionItem' }],
  ['COSTUMER_HOME_SPACE', { module: urlModulDesktop + '/costumer-home-place', component: 'costumer-home-place' }],
]);

export const componentDetailContractViews = new Map([]);
